import { inject, injectable } from "inversify";
import IAlertService from "../alert/IAlertService";
import { DiTokens } from "../diTokens";
import IErrorService from "../error/IErrorService";
import BaseOperationService from "../operations/BaseOperationService";
import i18n from "@/i18n";
import { CashBackCategoryModel } from "fs-pb-vue2/models/cardOperations/CashBackCategoryModel"

/** Сервис проведения операций выбора категории кэшбэка */
@injectable()
export default class CashBackSelectService extends BaseOperationService {
  constructor(
    @inject(DiTokens.AlertService) public alertService: IAlertService,
    @inject(DiTokens.ErrorService) public errorService: IErrorService
  ) {
    super(alertService, errorService);
  }

  /**
   * Инициализация операции
   * @param initData Данные для инициализации
   * */
  public async init(params: any): Promise<CashBackCategoryModel> {
    const operationData = new CashBackCategoryModel(params);
    operationData.RespondentCode = params.code;
    return operationData;
  }

  public async nextStep(model: CashBackCategoryModel): Promise<CashBackCategoryModel> {
    model = await this.execute(model) as CashBackCategoryModel;
    return model;
  }

  /**
   * Действия после проведения операции
   */
  public async afterExecute( model: CashBackCategoryModel ): Promise<void> {
    if (model.IsSuccess) {
      this.alertService.success(i18n.t("main.cashBack.success").toString(), false);
    } else if (model.IsError) {
      this.alertService.error(i18n.t("main.cashBack.error").toString(), false);
    } else if (model.IsExecuting) {
      this.alertService.warning(i18n.t("main.cashBack.executing").toString(), false);
    }
  }
}
